import { render, staticRenderFns } from "./ChatWidgetSettingsContent.vue?vue&type=template&id=f9a3f5e4"
import script from "./ChatWidgetSettingsContent.vue?vue&type=script&lang=js"
export * from "./ChatWidgetSettingsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports